import {
    ComponentVendorAssessmentResult,
    ComponentVendorAssessmentStatus,
    ComponentVendorAssessmentType,
} from '@gql/graphql';

export function vendorAssessmentType(
    vendorType: ComponentVendorAssessmentType,
): string {
    switch (vendorType) {
        case ComponentVendorAssessmentType.Cots:
            return 'Cots';
        case ComponentVendorAssessmentType.Oss:
            return 'Oss';
        case ComponentVendorAssessmentType.Individual:
            return 'Individual';
        case ComponentVendorAssessmentType.Service:
            return 'Service';
        default:
            return 'Unknown';
    }
}

export function vendorAssessmentResult(
    result?: ComponentVendorAssessmentResult,
): string {
    switch (result) {
        case ComponentVendorAssessmentResult.Ok:
            return 'OK';
        case ComponentVendorAssessmentResult.Withdrawn:
            return 'Withdrawn';
        case ComponentVendorAssessmentResult.Notrecommended:
            return 'Not Recommended';
        case ComponentVendorAssessmentResult.Okwithopenissues:
            return 'Ok with open issues';
        default:
            return 'None';
    }
}

export function vendorAssessmentStatus(
    status?: ComponentVendorAssessmentStatus,
): string {
    switch (status) {
        case ComponentVendorAssessmentStatus.Completed:
            return 'Completed';
        case ComponentVendorAssessmentStatus.Inprogress:
            return 'In Progress';
        default:
            return 'Not Assessed';
    }
}
